/*
 * @Description: 产品管理
 * @Date: 2022-09-21 13:31:45
 */

import { route } from './src/router';

const name = 'product-mgmt';

export { name, route };
